/* Cakesomarvellous "Lights Off, Candle On", revision 1: behaviours for the default home, product and cart templates
   (revision 1 became the base on 5 Oct 2026; revision 2 stays reachable as ?view=rev2 with its own csm-candle.js).
   Links are plain URLs: nothing here adds a ?view parameter.
   No libraries. Talks to the cart through Shopify's Ajax API and lets csm-marvellous-deal.js handle the gift. */
(function () {
  "use strict";
  var html = document.documentElement;
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var params = new URLSearchParams(location.search);
  var cfg = window.csmCandle || {};
  var routes = window.routes || {};
  var GIFT = Number(cfg.giftVariantId) || 0;
  var CART_URL = routes.cart_url || "/cart";
  var ADD_URL = (routes.cart_add_url || "/cart/add") + ".js";
  var CHANGE_URL = (routes.cart_change_url || "/cart/change") + ".js";
  var UPDATE_URL = (routes.cart_update_url || "/cart/update") + ".js";
  var reduceMotion = function () { return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches; };

  /* Money: "$29" / "$25.90" in listings (trim), "$29.00" in the cart */
  var money = function (cents, trim) {
    var v = Math.round(cents) / 100;
    if (trim && Math.round(v * 100) % 100 === 0) return "$" + v.toLocaleString("en-SG");
    return "$" + v.toLocaleString("en-SG", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  var jsonFetch = function (url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ "Content-Type": "application/json", Accept: "application/json" }, opts.headers || {});
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (body) {
        if (!r.ok) { var e = new Error(body.description || body.message || ("HTTP " + r.status)); e.body = body; throw e; }
        return body;
      });
    });
  };
  var getCart = function () { return jsonFetch(CART_URL + ".js", { method: "GET", headers: {} }); };

  /* Tell the A Marvellous Deal script (and anything else listening) that the cart changed */
  var announce = function () {
    try { if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") publish(PUB_SUB_EVENTS.cartUpdate, { source: "csm-candle" }); } catch (e) { /* never break the page */ }
    try { document.dispatchEvent(new CustomEvent("csm:cart-changed")); } catch (e) { /* old browsers */ }
  };

  /* Header cart count: cakes only (the free gift is not counted) */
  var setCount = function (cart) {
    var n = 0;
    (cart.items || []).forEach(function (i) { if (i.variant_id !== GIFT) n += i.quantity; });
    qsa("[data-cart-count]").forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    return cart;
  };
  var refreshCount = function () { return getCart().then(setCount).catch(function () {}); };
  document.addEventListener("csm:deal-synced", refreshCount);

  /* ---------- Menu ---------- */
  var menuBtn = qs(".menu-btn");
  var menu = qs("#menu");
  if (menuBtn && menu) {
    menuBtn.addEventListener("click", function () {
      var open = menuBtn.getAttribute("aria-expanded") === "true";
      menuBtn.setAttribute("aria-expanded", String(!open));
      menu.classList.toggle("is-open", !open);
    });
  }

  /* ---------- Floating WhatsApp: only after the hero has scrolled away ---------- */
  var wa = qs(".wa-float");
  var heroEl = qs(".hero");
  if (wa && heroEl && "IntersectionObserver" in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { wa.classList.toggle("is-on", !e.isIntersecting); });
    }, { threshold: 0 }).observe(heroEl);
  } else if (wa) { wa.classList.add("is-on"); }

  /* ---------- Landing on an anchor from another page (e.g. a Deal badge: /#deal) ----------
     The browser jumps to the target while the page is still settling (fonts, photos, app widgets above it), so the
     target can end up off its mark. Re-align it once things have loaded, unless the visitor has started scrolling. */
  (function () {
    var h = location.hash;
    if (!h || h.length < 2 || !/^#[A-Za-z][\w-]*$/.test(h)) return;
    var target = document.getElementById(h.slice(1));
    if (!target) return;
    var touched = false;
    ["wheel", "touchstart", "keydown", "mousedown"].forEach(function (ev) {
      window.addEventListener(ev, function () { touched = true; }, { once: true, passive: true });
    });
    var align = function () { if (!touched) target.scrollIntoView({ behavior: "instant", block: "start" }); };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(align);
    window.addEventListener("load", function () { align(); setTimeout(align, 700); });
  })();

  /* ---------- Lighting the candle (home hero, once), the line-up and the 4″ sign ---------- */
  if (html.classList.contains("js-anim")) {
    var heroImg = qs(".hero .pool img");
    if (heroImg) {
      var lit = false;
      var light = function () {
        if (lit) return; lit = true;
        requestAnimationFrame(function () { requestAnimationFrame(function () { html.classList.add("is-lit"); }); });
      };
      var ready = heroImg.decode ? heroImg.decode() : Promise.resolve();
      ready.then(function () { setTimeout(light, 220); }, light);
      setTimeout(light, 1600);
    } else {
      html.classList.add("is-lit");
    }

    /* The line-up: one candle mid-stage; scrolling slides the row of cakes through its light.
       Each cake owns an equal share of the scroll run: it holds fully lit for 84% of it, and the
       hand-over to the next takes the last 16% on an ease-in-out cubic. Only transform and opacity change. */
    var lineup = qs(".lineup");
    var lTrack = qs(".lineup__track");
    var lCakes = qsa(".lineup .cake");
    if (lineup && lTrack && lCakes.length > 1) {
      var nC = lCakes.length, stride = 0, first = 0, lTick = false;
      var measure = function () {
        stride = lCakes[1].offsetLeft - lCakes[0].offsetLeft;
        first = lCakes[0].offsetLeft + lCakes[0].offsetWidth / 2;
      };
      var HOLD = 0.84;
      var ease = function (t) { t = Math.min(1, Math.max(0, (t - HOLD) / (1 - HOLD))); return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
      var place = function () {
        lTick = false;
        var run = Math.max(1, lineup.offsetHeight - window.innerHeight);
        var p = Math.min(1, Math.max(0, -lineup.getBoundingClientRect().top / run));
        var s = p * nC, k = Math.min(nC - 1, Math.floor(s));
        var f = k < nC - 1 ? k + ease(s - k) : k;
        var tx = document.documentElement.clientWidth / 2 - first - f * stride;
        lTrack.style.transform = "translate3d(" + tx.toFixed(1) + "px,0,0)";
        for (var c = 0; c < nC; c++) {
          var l = Math.max(0, 1 - Math.abs(c - f));
          /* squared: mid hand-over both cakes sit in shadow for a beat, never a grey half-light */
          lCakes[c].style.setProperty("--lit", (l * l).toFixed(3));
        }
      };
      var queue = function () { if (!lTick) { lTick = true; requestAnimationFrame(place); } };
      measure(); place();
      window.addEventListener("scroll", queue, { passive: true });
      window.addEventListener("resize", function () { measure(); queue(); }, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(); place(); });
      /* Keyboard: tabbing to a cake scrolls the page to the point where that cake is in the light */
      lCakes.forEach(function (cake, i) {
        cake.addEventListener("focusin", function () {
          var run = lineup.offsetHeight - window.innerHeight;
          var top = lineup.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo(0, top + run * (i + HOLD / 2) / nC);
          place();
        });
      });
    }

    /* The Deal band's 4″ is a sign: unlit cream until it first comes into view, then lit orange, once */
    var band = qs(".deal-band");
    var four = qs(".deal-band .four, .deal-band .ring--four");
    if (band && four) {
      if ("IntersectionObserver" in window) {
        var fourIO = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { band.classList.add("is-lit"); fourIO.disconnect(); } });
        }, { threshold: 0.9, rootMargin: "0px 0px -12% 0px" });
        fourIO.observe(four);
      } else { band.classList.add("is-lit"); }
    }
  }

  /* ---------- The delivery calendar: the same rules as the jQuery cart picker and the Schedule page ---------- */
  var DOW = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  var MON = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var pad2 = function (n) { return String(n).padStart(2, "0"); };
  var ddmmyyyy = function (dt) { return pad2(dt.getDate()) + "-" + pad2(dt.getMonth() + 1) + "-" + dt.getFullYear(); };
  var parseDdmmyyyy = function (s) {
    var m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(String(s || "").trim());
    return m ? new Date(+m[3], +m[2] - 1, +m[1]) : null;
  };
  var Calendar = (function () {
    var el = document.getElementById("csm-calendar-data");
    if (!el) return null;
    var data = {};
    try { data = JSON.parse(el.textContent); } catch (e) { data = {}; }
    var blocked = {};
    (Array.isArray(data.blocked) ? data.blocked : []).forEach(function (s) { blocked[String(s).trim()] = 1; });
    var cutoff = Number(data.cutoffHour) || 14;
    var maxDays = Number(data.maxDays) || 60;
    /* "Now" in Singapore, whatever the phone's own time zone */
    var y, m, d, h;
    try {
      var parts = {};
      new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Singapore", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", hourCycle: "h23" })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      y = +parts.year; m = +parts.month; d = +parts.day; h = (+parts.hour) % 24;
    } catch (e) {
      var n = new Date(); y = n.getFullYear(); m = n.getMonth() + 1; d = n.getDate(); h = n.getHours();
    }
    var today = new Date(y, m - 1, d);
    var addDays = function (dt, k) { return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + k); };
    var tomorrow = addDays(today, 1);
    var last = addDays(today, maxDays);
    var status = function (dt) {
      if (dt <= today || dt > last) return "past";
      if (dt.getTime() === tomorrow.getTime() && h >= cutoff) return "blocked";
      if (blocked[ddmmyyyy(dt)]) return "blocked";
      return "open";
    };
    var nextOpen = function () {
      for (var k = 1; k <= maxDays; k++) { var dt = addDays(today, k); if (status(dt) === "open") return dt; }
      return null;
    };
    return { today: today, tomorrow: tomorrow, last: last, status: status, nextOpen: nextOpen, addDays: addDays };
  })();
  var inWords = function (dt) { return DOW[dt.getDay()] + " " + dt.getDate() + " " + MON[dt.getMonth()]; };
  var shortDate = function (dt) { return DOW[dt.getDay()].slice(0, 3) + " " + dt.getDate() + " " + MON[dt.getMonth()].slice(0, 3); };

  /* ---------- The customer's date (5 Oct 2026): the cart attribute "date", dd-mm-yyyy ----------
     The same attribute the cart's calendar reads and writes, so a date picked on the homepage, the delivery dates page
     or a product page's dates panel is already picked in the cart (and changing it in the cart overwrites it).
     /cart/update.js works on an empty cart too. A saved date that is no longer open is ignored here (the cart clears it). */
  var DateStore = (function () {
    var subs = [], date = null, loading = null;
    var tell = function () { subs.forEach(function (f) { f(date); }); };
    return {
      get: function () { return date; },
      sub: function (f) { subs.push(f); },
      load: function () {
        if (!loading) {
          loading = getCart().then(function (c) {
            var d = parseDdmmyyyy(c && c.attributes && c.attributes.date);
            date = d && Calendar && Calendar.status(d) === "open" ? d : null;
            Where.fromCart(c && c.attributes && c.attributes.postcode);
            tell();
            return date;
          }).catch(function () { return null; });
        }
        return loading;
      },
      save: function (d) {
        date = d; tell();
        return jsonFetch(UPDATE_URL, { method: "POST", body: JSON.stringify({ attributes: dateAttrs(d) }) });
      },
      /* the cart page keeps its own copy of the date; it tells the store so the shared state stays one */
      put: function (d) { date = d; tell(); }
    };
  })();

  /* ---------- Postcode first (Philip, 5 Oct 2026) ----------
     Every date picker starts with Delivery + the postal code, or Self-collect (snippet csm-candle-postcode). One shared
     state for the page: { mode: "delivery" | "collect", pc: "760123" }, remembered in the browser (csm-where) and saved
     to the cart attribute `postcode` TOGETHER WITH the date, date first: the sheet's order import reads the attribute
     `date`, and writing them in one request keeps `date` the first attribute on the order. When the date is cleared,
     the postcode attribute goes too (the browser keeps it and it is written again with the next date). */
  var Where = (function () {
    var KEY = "csm-where", subs = [];
    var st = { mode: "delivery", pc: "" };
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || "{}");
      if (s.mode === "collect") st.mode = "collect";
      if (/^\d{6}$/.test(s.pc || "")) st.pc = s.pc;
    } catch (e) { /* private mode */ }
    var keep = function () { try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) { /* private mode */ } };
    return {
      get: function () { return st; },
      sub: function (f) { subs.push(f); },
      set: function (patch, quiet) {
        var changed = false;
        Object.keys(patch).forEach(function (k) { if (st[k] !== patch[k]) { st[k] = patch[k]; changed = true; } });
        if (!changed) return false;
        keep();
        if (!quiet) subs.forEach(function (f) { f(st); });
        return true;
      },
      /* a postcode already on the cart wins over the browser's (it is what the customer last confirmed) */
      fromCart: function (pc) { if (/^\d{6}$/.test(pc || "")) this.set({ pc: pc }); }
    };
  })();
  /* A new postcode or mode after the date was saved: write both again (date first) */
  Where.sub(function () {
    var d = DateStore.get();
    if (d) jsonFetch(UPDATE_URL, { method: "POST", body: JSON.stringify({ attributes: dateAttrs(d) }) }).catch(function () {});
  });
  var dateAttrs = function (d) {
    var w = Where.get();
    var pc = d && w.mode === "delivery" && /^\d{6}$/.test(w.pc) ? w.pc : "";
    return { date: d ? ddmmyyyy(d) : "", postcode: pc };
  };
  /* The zone lookup (assets/csm-postcode-zones.js, generated from the Shopify zones) loads on first use */
  var zonesP = null;
  var loadZones = function () {
    if (window.csmPostcodeZone) return Promise.resolve(window.csmPostcodeZone);
    if (!zonesP) {
      zonesP = new Promise(function (res, rej) {
        var s = document.createElement("script");
        s.src = cfg.zonesUrl; s.async = true;
        s.onload = function () { res(window.csmPostcodeZone); };
        s.onerror = function () { zonesP = null; rej(new Error("zones")); };
        document.head.appendChild(s);
      });
    }
    return zonesP;
  };
  /* earliestFor(postcode): the first date we can deliver to (or the customer can collect for) this postcode.
     TODAY every postcode gets the same answer: the Schedule's blocked dates + the 2pm cut-off (Calendar.nextOpen()).
     ROUTE-AWARE HOOK: when the availability service knows the van's route, this is where the nearby-day logic plugs in
     (days the van already passes near this postcode first; see the delivery-clustering note and docs/business-rules.md
     §5, §8). Every "earliest" on the site goes through this one function, so only it has to change. */
  var earliestFor = function (pc, mode) { return Calendar ? Calendar.nextOpen() : null; };
  var advertised = function () { return money(cfg.dealAdvertisedCents || 5500, true); };
  /* The fee line for a zone (cents): "Delivery to 760123: $8, free from $55" */
  var zoneText = function (z) {
    if (z.area === "islandwide") return "<b>Delivery to " + z.postcode + ": " + money(z.fee, true) + "</b>, free from " + advertised() + ".";
    return "<b>" + z.label + " delivery to " + z.postcode + ": " + money(z.fee, true) + "</b>, " + money(z.dealFee, true) + " from " + advertised() +
      " (includes the " + money(z.fee - (cfg.deliveryFeeCents || 800), true) + " " + z.label + " surcharge).";
  };
  var waFor = function (st, d) {
    var who = st.mode === "collect" ? "to self-collect in Yishun" : (st.pc ? "a delivery to " + st.pc : "a delivery");
    return "https://wa.me/" + (cfg.wa || "6593535012") + "?text=" + encodeURIComponent(
      d ? "Hi! I’d like " + who + " on " + inWords(d) + ", which shows full or closed. Can you fit me in?"
        : "Hi! I’d like " + who + " on a date that shows full or closed: ____. Can you fit me in?");
  };
  /* Dim a calendar until it can be used: "Enter your postal code to see your earliest date" over the days */
  var gateCal = function (cal, text) {
    if (!cal) return;
    var w = qs("[data-cal-wait]", cal);
    if (!w) { w = document.createElement("p"); w.className = "cal__wait"; w.setAttribute("data-cal-wait", ""); cal.appendChild(w); }
    cal.classList.toggle("is-waiting", !!text);
    w.textContent = text || "";
    qsa(".cal__grid, .cal__head button", cal).forEach(function (n) { if (text) n.setAttribute("inert", ""); else n.removeAttribute("inert"); });
  };
  /* Wire one [data-pc] block. onState({ mode, pc, zone, ready }) runs on every change; ready = the calendar can be used
     (self-collect, or a postcode we deliver to). */
  var postcodeStep = function (box, onState) {
    var input = qs("[data-pc-input]", box), msg = qs("[data-pc-msg]", box), go = qs("[data-pc-go]", box);
    var modes = qsa("[data-pc-mode]", box);
    var hint = msg ? msg.innerHTML : "";
    var zone = null, typed = false, lastKey = null;
    var state = function () {
      var w = Where.get();
      var ready = w.mode === "collect" || !!(zone && zone.ok);
      return { mode: w.mode, pc: zone && zone.ok ? zone.postcode : "", zone: zone, ready: ready };
    };
    var say = function (txt, err) { if (!msg) return; msg.innerHTML = txt; msg.classList.toggle("is-error", !!err); if (input) input.setAttribute("aria-invalid", err ? "true" : "false"); };
    var draw = function () {
      var w = Where.get();
      box.classList.toggle("is-collect", w.mode === "collect");
      modes.forEach(function (m) { m.checked = m.value === w.mode; });
      if (!zone) say(hint, false);
      else if (zone.ok) say(zoneText(zone), false);
      else if (zone.why === "none") say("We can’t deliver to " + zone.postcode + ": Kusu, St John’s and Lazarus Islands are reached only by ferry. Please choose Self-collect.", true);
      else if (zone.why === "unknown") say("We can’t find " + zone.postcode + ". Please check the postal code, or WhatsApp us.", true);
      else say("Please enter the 6 digits of your postal code.", true);
      /* tell the page only when something it shows changed (a re-check on blur must not undo a tapped full day) */
      var s = state(), key = s.mode + "|" + s.pc + "|" + s.ready + "|" + (zone ? zone.why || zone.area : "");
      if (key === lastKey) return;
      lastKey = key;
      onState(s);
    };
    var check = function (strict) {
      var v = (input.value || "").replace(/\D/g, "").slice(0, 6);
      if (input.value !== v) input.value = v;
      if (v.length < 6) {
        zone = strict && v.length ? { ok: false, why: "format", postcode: v } : null;
        if (!v.length) Where.set({ pc: "" }, true);
        draw();
        return Promise.resolve();
      }
      return loadZones().then(function (fn) {
        zone = fn(v);
        if (zone.ok) Where.set({ pc: v });
        draw();
      }, function () { say("Sorry, we couldn’t check that just now. Please try again.", true); });
    };
    if (input) {
      input.addEventListener("input", function () { typed = true; check(false); });
      input.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); check(true); } });
      input.addEventListener("blur", function () { if (typed && input.value) check(true); });
    }
    if (go) go.addEventListener("click", function () { check(true); });
    modes.forEach(function (m) { m.addEventListener("change", function () { if (m.checked) { Where.set({ mode: m.value }); } }); });
    /* another picker on the page (or the cart) changed it */
    Where.sub(function (w) {
      if (input && w.pc && w.pc !== input.value) { input.value = w.pc; check(true); return; }
      draw();
    });
    var w0 = Where.get();
    if (input && w0.pc) { input.value = w0.pc; check(true); } else draw();
    return { state: state, refresh: draw, focus: function () { if (input && Where.get().mode === "delivery") input.focus(); } };
  };
  var whenText = function (dt) { return dt.getDay() === 0 ? "12pm–4pm" : "10am–3pm"; };
  var orderBy = function (dt) {
    var by = Calendar.addDays(dt, -1);
    return "Order by 2pm " + (by.getTime() === Calendar.today.getTime() ? "today" : "on " + shortDate(by));
  };
  /* One day of a calendar: a button. Past days are disabled; full or closed days are aria-disabled (a tap explains
     why); the label always says which ("Wednesday 7 October, full or closed"). */
  var dayButton = function (dt, picked, onPick) {
    var st = Calendar.status(dt);
    var b = document.createElement("button");
    b.type = "button";
    b.className = "day " + (st === "blocked" ? "full" : st);
    b.textContent = dt.getDate();
    b.setAttribute("data-t", dt.getTime());
    if (dt.getTime() === Calendar.today.getTime()) b.classList.add("today");
    var on = !!(picked && picked.getTime() === dt.getTime());
    b.setAttribute("aria-label", inWords(dt) + ", " + (st === "past" ? "unavailable" : st === "blocked" ? "full or closed" : on ? "your date" : "open"));
    if (st === "past") b.disabled = true;
    else {
      if (st === "blocked") b.setAttribute("aria-disabled", "true");
      else b.setAttribute("aria-pressed", String(on));
      b.addEventListener("click", function () { onPick(dt, st); });
    }
    return b;
  };
  /* Redrawing replaces the buttons: give the focus back to the day that was tapped */
  var refocus = function (grid, t) { if (t) { var f = qs('[data-t="' + t + '"]', grid); if (f) f.focus(); } };
  /* A month calendar (the cart's look): [data-cal-grid], [data-cal-title], [data-cal-prev], [data-cal-next] */
  var monthCal = function (root, opts) {
    var grid = qs("[data-cal-grid]", root), title = qs("[data-cal-title]", root);
    var prev = qs("[data-cal-prev]", root), next = qs("[data-cal-next]", root);
    var start = opts.pick() || Calendar.nextOpen() || Calendar.tomorrow;
    var shown = new Date(start.getFullYear(), start.getMonth(), 1);
    var focusT = 0;
    var draw = function () {
      title.textContent = MON[shown.getMonth()] + " " + shown.getFullYear();
      var firstMonth = new Date(Calendar.tomorrow.getFullYear(), Calendar.tomorrow.getMonth(), 1);
      var lastMonth = new Date(Calendar.last.getFullYear(), Calendar.last.getMonth(), 1);
      prev.disabled = shown <= firstMonth;
      next.disabled = shown >= lastMonth;
      qsa(".day, .pad", grid).forEach(function (n) { n.remove(); });
      var first = new Date(shown.getFullYear(), shown.getMonth(), 1);
      for (var p = 0; p < (first.getDay() + 6) % 7; p++) { var padEl = document.createElement("span"); padEl.className = "pad"; grid.appendChild(padEl); }
      var days = new Date(shown.getFullYear(), shown.getMonth() + 1, 0).getDate();
      var pick = opts.pick(), nx = !pick && opts.next ? opts.next() : null;
      for (var i = 1; i <= days; i++) {
        var db = dayButton(new Date(shown.getFullYear(), shown.getMonth(), i), pick, function (d, st) { focusT = d.getTime(); opts.onPick(d, st); draw(); });
        if (nx && Number(db.getAttribute("data-t")) === nx.getTime()) db.classList.add("is-next");
        grid.appendChild(db);
      }
      refocus(grid, focusT); focusT = 0;
    };
    prev.addEventListener("click", function () { shown = new Date(shown.getFullYear(), shown.getMonth() - 1, 1); draw(); });
    next.addEventListener("click", function () { shown = new Date(shown.getFullYear(), shown.getMonth() + 1, 1); draw(); });
    return { draw: draw, show: function (d) { if (d) { shown = new Date(d.getFullYear(), d.getMonth(), 1); draw(); } } };
  };

  /* The "earliest / your date" panel under a calendar, shared by the homepage week, the schedule page and the product
     page's dates panel. el = { label, date, when, by } nodes (any may be missing); st = the postcode step's state. */
  var sayEarliest = function (el, st, pick, full) {
    var set = function (n, t) { if (n) n.textContent = t; };
    var collect = st.mode === "collect";
    var hours = function (d) { return collect ? "Self-collect in Yishun, 6–9pm" : "Delivery " + whenText(d) + (d.getDay() === 0 ? " (Sunday)" : ""); };
    if (el.box) el.box.classList.toggle("is-empty", !st.ready && !pick && !full);
    if (full) { set(el.label, "Full or closed"); set(el.date, inWords(full)); set(el.when, "Please pick another day, or WhatsApp us below."); set(el.by, ""); return; }
    if (pick) { set(el.label, el.pickedLabel || "Your date"); set(el.date, inWords(pick)); set(el.when, hours(pick)); set(el.by, ""); return; }
    if (!st.ready) {
      set(el.label, "Your earliest date");
      set(el.date, st.zone && !st.zone.ok ? "Self-collect, or WhatsApp us" : "Enter your postal code above");
      set(el.when, ""); set(el.by, ""); return;
    }
    var nx = earliestFor(st.pc, st.mode);
    if (!nx) { set(el.label, "Next open date"); set(el.date, "WhatsApp us for a date"); set(el.when, ""); set(el.by, ""); return; }
    set(el.label, collect ? "Earliest collection" : "Earliest for " + st.pc);
    set(el.date, inWords(nx));
    set(el.when, hours(nx));
    set(el.by, orderBy(nx));
  };
  var STEP_WAIT = "Enter your postal code to see your earliest date";
  var stepWait = function (st) { return st.ready ? "" : (st.zone && !st.zone.ok && st.zone.why === "none" ? "No delivery to this postcode: choose Self-collect" : STEP_WAIT); };
  var setWa = function (scope, st, d) { qsa("[data-wa-full]", scope).forEach(function (a) { a.href = waFor(st, d); }); };

  /* Home: this week from the live calendar, as a picker: postcode (or Self-collect) first, then the week with the
     earliest date outlined; tapping an open day saves it ("Your date: Tuesday 6 October" + Choose your cake). */
  var week = qs("[data-week]");
  if (week && Calendar) {
    var wStart = Calendar.tomorrow;
    var monday = Calendar.addDays(wStart, -((wStart.getDay() + 6) % 7));
    var wGrid = qs("[data-week-grid]", week);
    var wFull = null, wFail = false, wFocus = 0;
    var wSt = { mode: "delivery", pc: "", zone: null, ready: false };
    var wEl = { box: qs(".chosen", week), label: qs("[data-week-label]", week), date: qs("[data-week-next]", week), when: qs("[data-week-when]", week), pickedLabel: week.getAttribute("data-picked-label") };
    var wSay = function () {
      var pick = DateStore.get();
      var go = qs("[data-week-go]", week), note = qs("[data-week-note]", week);
      sayEarliest(wEl, wSt, wSt.ready ? pick : null, wFull);
      if (wEl.when && !wFull && !pick && wSt.ready) { var nx = earliestFor(wSt.pc, wSt.mode); if (nx) wEl.when.textContent += " · " + orderBy(nx).replace(/^Order/, "order"); }
      if (go) go.hidden = !(pick && wSt.ready && !wFull);
      if (note) {
        note.hidden = !(pick && wSt.ready && !wFull);
        note.textContent = wFail ? "We couldn’t save it just now. Please try again." : (week.getAttribute("data-saved-note") || "Saved for your cart. Change it any time.");
      }
      setWa(week, wSt, wFull);
      gateCal(qs(".cal", week), stepWait(wSt));
    };
    var wDraw = function () {
      qsa(".day", wGrid).forEach(function (n) { n.remove(); });
      var pick = DateStore.get(), next = wSt.ready ? earliestFor(wSt.pc, wSt.mode) : null;
      for (var i = 0; i < 7; i++) {
        var b = dayButton(Calendar.addDays(monday, i), pick, function (d, st) {
          wFocus = d.getTime(); wFail = false;
          if (st === "open") { wFull = null; DateStore.save(d).catch(function () { wFail = true; wSay(); }); }
          else { wFull = d; wDraw(); wSay(); }
        });
        if (!pick && next && Number(b.getAttribute("data-t")) === next.getTime()) b.classList.add("is-next");
        wGrid.appendChild(b);
      }
      refocus(wGrid, wFocus); wFocus = 0;
    };
    qs("[data-week-month]", week).textContent = MON[monday.getMonth()] + " " + monday.getFullYear();
    DateStore.sub(function () { wDraw(); wSay(); });
    var wBox = qs("[data-pc]", week);
    week.hidden = false;
    if (wBox) postcodeStep(wBox, function (st) { wSt = st; wFull = null; wDraw(); wSay(); });
    else { wSt.ready = true; wDraw(); wSay(); }
    DateStore.load();
  }

  /* ---------- Delivery dates page: postcode (or Self-collect) first, then the cart's month calendar; picking an open
     date saves it for the cart ---------- */
  var sched = qs("[data-schedule]");
  if (sched && Calendar) {
    var sFull = null, sFail = false;
    var sSt = { mode: "delivery", pc: "", zone: null, ready: false };
    var sEl = { box: qs("[data-chosen]", sched), label: qs("[data-c-label]", sched), date: qs("[data-c-date]", sched), when: qs("[data-c-when]", sched), by: qs("[data-c-by]", sched), pickedLabel: sched.getAttribute("data-picked-label") };
    var sSay = function () {
      var go = qs("[data-c-go]", sched), waL = qs("[data-c-wa]", sched), note = qs("[data-c-note]", sched);
      var pick = sSt.ready ? DateStore.get() : null;
      sayEarliest(sEl, sSt, pick, sFull);
      if (go) go.hidden = !(sSt.ready && !sFull);
      if (waL) waL.hidden = !sFull;
      if (note) {
        note.hidden = !(pick && !sFull);
        note.textContent = sFail ? "We couldn’t save it just now. Please try again." : (sched.getAttribute("data-saved-note") || "Saved for your cart.");
      }
      setWa(sched, sSt, sFull);
      gateCal(qs("[data-cal]", sched), stepWait(sSt));
    };
    var sCal = monthCal(qs("[data-cal]", sched), {
      pick: DateStore.get,
      next: function () { return sSt.ready ? earliestFor(sSt.pc, sSt.mode) : null; },
      onPick: function (d, st) {
        sFail = false;
        if (st === "open") { sFull = null; DateStore.save(d).catch(function () { sFail = true; sSay(); }); }
        else { sFull = d; }
        sSay();
      }
    });
    DateStore.sub(function () { sCal.draw(); sSay(); });
    var sBox = qs("[data-pc]", sched);
    if (sBox) postcodeStep(sBox, function (st) { sSt = st; sFull = null; sCal.draw(); sSay(); });
    else { sSt.ready = true; sCal.draw(); sSay(); }
    DateStore.load().then(function (d) { if (d) sCal.show(d); });
  }

  /* ---------- In-page panels (product pages): a <dialog>, a bottom sheet on phones; "pop" ones sit by their opener
     on wider screens. Esc, the backdrop and the close button close it; the rest of the page is inert while it is open
     (showModal), and the focus goes back to what opened it. ---------- */
  var canSheet = !!(window.HTMLDialogElement && document.createElement("dialog").showModal);
  var Sheet = function (dlg, pop) {
    var opener = null;
    var wide = window.matchMedia("(min-width: 720px)");
    if (pop) dlg.classList.add("sheet--pop");
    var place = function () {
      if (!dlg.open) return;
      if (pop && wide.matches && opener) {
        var r = opener.getBoundingClientRect(), w = dlg.offsetWidth, h = dlg.offsetHeight;
        var left = Math.min(Math.max(16, r.left), window.innerWidth - w - 16);
        var top = r.bottom + 10;
        // below the opener; if it does not fit, as close to it as the screen allows (over it)
        if (top + h > window.innerHeight - 16) top = Math.max(16, Math.min(r.top - 24, window.innerHeight - h - 16));
        dlg.style.left = left + "px"; dlg.style.top = top + "px";
        dlg.classList.add("is-anchored");
      } else {
        dlg.style.left = ""; dlg.style.top = "";
        dlg.classList.remove("is-anchored");
      }
    };
    var close = function () { if (dlg.open) dlg.close(); };
    dlg.addEventListener("click", function (e) { if (e.target === dlg) close(); });
    qsa("[data-sheet-close]", dlg).forEach(function (b) { b.addEventListener("click", close); });
    dlg.addEventListener("close", function () {
      html.classList.remove("has-sheet");
      if (opener && document.contains(opener)) { try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); } }
    });
    window.addEventListener("resize", place, { passive: true });
    return {
      open: function (from) {
        opener = from || document.activeElement;
        if (!dlg.open) { html.classList.add("has-sheet"); dlg.showModal(); }
        place();
        var h = qs("h2", dlg); if (h) h.focus();
      },
      close: close,
      isOpen: function () { return dlg.open; },
      place: place
    };
  };

  /* ---------- Product page ---------- */
  var pdp = qs("[data-pdp]");
  var pjEl = qs("[data-product-json]");
  if (pdp && pjEl) {
    var P = JSON.parse(pjEl.textContent);
    var form = qs("[data-product-form]", pdp);
    var qty = 1;
    var priceEl = qs("[data-price]", pdp);
    var dealEl = qs("[data-deal-line]", pdp);
    var addBtns = qsa("[data-add]");
    var sbMeta = qs("[data-sb-meta]");
    var qOut = qs("[data-qty]", pdp);
    var qIn = qs("[data-qty-input]", pdp);
    var idIn = qs("[data-variant-id]", pdp);
    var addedLine = qs("[data-added]", pdp);
    var nOpts = P.variants.length ? P.variants[0].options.length : 0;
    var lab = function (v) { return (P.labels[v] && P.labels[v].label) || v; };
    var meta = function (v) { return (P.labels[v] && P.labels[v].meta) || ""; };

    var selected = function () {
      var o = [];
      for (var i = 0; i < nOpts; i++) {
        var c = qs('input[data-option="' + i + '"]:checked', form) || qs('input[type="hidden"][data-option="' + i + '"]', form);
        o.push(c ? c.value : null);
      }
      return o;
    };
    var find = function (opts) {
      for (var k = 0; k < P.variants.length; k++) {
        var v = P.variants[k], ok = true;
        for (var i = 0; i < nOpts; i++) if (opts[i] !== null && v.options[i] !== opts[i]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    };
    var current = function () { return nOpts ? find(selected()) : P.variants[0]; };
    var sizeText = function (v) {
      if (!v || P.sizePos < 0) return "";
      var sv = v.options[P.sizePos];
      return lab(sv) + (meta(sv) ? ", " + meta(sv) : "");
    };

    /* Per-flavour photos: slides (and their thumbnails) carry data-flav; picking a flavour shows only its photos
       and brings the first one into view. Slides without data-flav are always shown. */
    var track = qs(".gallery__track", pdp);
    var thumbs = qsa(".gallery__thumbs .thumb", pdp);
    var thumbsWrap = qs("[data-thumbs]", pdp);
    var slides = track ? qsa("figure", track) : [];
    var hasFlav = slides.some(function (f) { return f.hasAttribute("data-flav"); });
    var visThumbs = function () { return thumbs.filter(function (t) { return !t.hidden; }); };
    var lastGal = null;
    var syncGallery = function (opts) {
      if (!hasFlav) return;
      var key = opts.join("|");
      if (key === lastGal) return;
      var first = lastGal === null;
      lastGal = key;
      var k = 0;
      slides.forEach(function (f, i) {
        var fv = f.getAttribute("data-flav");
        var on = !fv || opts.indexOf(fv) > -1;
        f.hidden = !on;
        var t = thumbs[i];
        if (t) {
          t.hidden = !on;
          t.removeAttribute("aria-current");
          if (on) { t.setAttribute("data-i", k); t.setAttribute("aria-label", "Photo " + (k + 1) + (fv ? ": " + fv : "")); if (k === 0) t.setAttribute("aria-current", "true"); }
        }
        if (on) { if (k === 0) { var im = qs("img", f); if (im) im.loading = "eager"; } k++; }
      });
      if (thumbsWrap) thumbsWrap.hidden = k < 2;
      if (!first) track.scrollLeft = 0;
    };
    /* Fetch every flavour's photos once the page has settled, so switching flavour shows the photo at once */
    if (hasFlav) {
      var warm = function () { qsa("img", track).concat(qsa(".gallery__thumbs img", pdp)).forEach(function (im) { im.loading = "eager"; }); };
      if (document.readyState === "complete") setTimeout(warm, 800); else window.addEventListener("load", function () { setTimeout(warm, 800); });
    }

    var onRender = null, onAdded = null;
    var render = function () {
      var v = current();
      var opts = selected();
      if (!v) {
        addBtns.forEach(function (b) { b.disabled = true; var l = qs("[data-label]", b); if (l) l.textContent = "Unavailable"; });
        return;
      }
      var total = v.price * qty;
      priceEl.innerHTML = "";
      priceEl.appendChild(document.createTextNode(money(v.price, true)));
      var st = sizeText(v);
      if (st) { var sm = document.createElement("small"); sm.textContent = st; priceEl.appendChild(sm); }
      /* the Deal chip: "included" (with a tick) once this choice reaches it, else what is still to add */
      var dealSt = dealEl && qs("[data-deal-status]", dealEl);
      if (dealSt) {
        var on = total >= P.dealCents;
        dealEl.classList.toggle("is-on", on);
        dealSt.innerHTML = on ? '<svg class="icon" aria-hidden="true"><use href="#i-check"/></svg>' : "";
        dealSt.appendChild(document.createTextNode(on ? (P.dealOn || "included") : "Add " + money(P.advertisedCents - total, true) + " more"));
      }
      syncGallery(opts);
      /* allergen extras for one option value (e.g. Wasabi: may also contain mustard and soy) */
      qsa("[data-when]", pdp).forEach(function (w) { w.hidden = v.options.indexOf(w.getAttribute("data-when")) < 0; });
      qsa("[data-type-hint]", form).forEach(function (h) {
        var oi = Number(h.getAttribute("data-hint-option"));
        var hv = P.hints && P.hints[opts[oi]];
        if (hv) h.innerHTML = hv;
      });
      if (idIn) idIn.value = v.id;
      if (qIn) qIn.value = qty;
      addBtns.forEach(function (b) {
        b.disabled = !v.available;
        if (b.classList.contains("is-done")) return;
        var l = qs("[data-label]", b);
        if (!v.available) l.textContent = "Sold out";
        else l.textContent = b.hasAttribute("data-short") ? "Add to cart" : "Add to cart · " + money(total, true);
      });
      if (sbMeta) {
        var parts = [];
        v.options.forEach(function (o) { var t = lab(o); if (t && o !== "Default Title") parts.push(t); });
        parts.push(money(total, true));
        sbMeta.textContent = parts.join(" · ");
      }
      if (qOut) qOut.textContent = qty;
      /* tile prices for the other choices, given what else is picked */
      qsa("[data-tile-price]", form).forEach(function (tp) {
        var input = tp.closest(".opt").querySelector("input");
        var i = Number(input.getAttribute("data-option"));
        var o = opts.slice(); o[i] = input.value;
        var alt = find(o);
        tp.textContent = alt ? money(alt.price, true) : "";
      });
      qsa("[data-rail-row]").forEach(function (r) { r.classList.toggle("is-current", P.sizePos >= 0 && r.getAttribute("data-rail-row") === v.options[P.sizePos]); });
      /* "With a Medium: $69.90" on the cross-sells */
      var sl = P.sizePos >= 0 ? lab(v.options[P.sizePos]) : "";
      var pairsEl = qs("[data-pairs]");
      var noun = pairsEl ? pairsEl.getAttribute("data-pair-noun") : "";
      if (sl && noun) sl = sl + " " + noun;
      qsa("[data-pair-sum]").forEach(function (ps) {
        var pp = Number(ps.getAttribute("data-price"));
        if (pp >= P.dealCents) return;
        ps.innerHTML = "";
        ps.appendChild(document.createTextNode((sl ? "With a" + (/^[AEIOU8]/i.test(sl) ? "n " : " ") + sl : "With yours") + ": "));
        var b = document.createElement("b"); b.textContent = money(v.price + pp, true); ps.appendChild(b);
      });
      if (window.history && window.history.replaceState && nOpts) {
        var u = new URL(location.href); u.searchParams.set("variant", v.id);
        window.history.replaceState(null, "", u.toString());
      }
      if (onRender) onRender();
    };
    qsa("input[data-option]", form).forEach(function (i) { i.addEventListener("change", render); });
    qsa("[data-step]", pdp).forEach(function (b) {
      b.addEventListener("click", function () {
        qty = Math.max(1, Math.min(9, qty + Number(b.getAttribute("data-step"))));
        render();
      });
    });

    var busy = false;
    var add = function () {
      var v = current();
      if (!v || !v.available || busy) return;
      busy = true;
      addBtns.forEach(function (b) { b.setAttribute("aria-busy", "true"); });
      jsonFetch(ADD_URL, { method: "POST", body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] }) })
        .then(function () {
          addBtns.forEach(function (x) {
            x.classList.remove("is-lit"); void x.offsetWidth; x.classList.add("is-lit", "is-done");
            qs("[data-label]", x).textContent = x.hasAttribute("data-short") ? "Added" : "Added to your cart";
          });
          if (addedLine) {
            addedLine.classList.remove("is-error");
            addedLine.innerHTML = 'Added. <a href="' + CART_URL + '">View cart</a>';
          }
          if (onAdded) onAdded(v, qty);
          announce();
          return refreshCount();
        })
        .catch(function (err) {
          if (addedLine) { addedLine.classList.add("is-error"); addedLine.textContent = err.message || "Sorry, that didn’t work. Please try again."; }
        })
        .then(function () {
          busy = false;
          addBtns.forEach(function (b) { b.removeAttribute("aria-busy"); });
          setTimeout(function () { addBtns.forEach(function (x) { x.classList.remove("is-done"); }); render(); }, 2200);
        });
    };
    form.addEventListener("submit", function (e) { e.preventDefault(); add(); });
    addBtns.forEach(function (b) { if (b.type !== "submit") b.addEventListener("click", add); });
    render();

    /* Cross-sells: add one */
    qsa("[data-pair-add]").forEach(function (b) {
      b.addEventListener("click", function () {
        var id = Number(b.getAttribute("data-pair-add"));
        b.disabled = true;
        jsonFetch(ADD_URL, { method: "POST", body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
          .then(function () {
            qs("[data-label]", b).textContent = "Added";
            announce();
            if (addedLine) { addedLine.classList.remove("is-error"); addedLine.innerHTML = 'Added. <a href="' + CART_URL + '">View cart</a>'; }
            return refreshCount();
          })
          .catch(function () { qs("[data-label]", b).textContent = "Try again"; })
          .then(function () { setTimeout(function () { b.disabled = false; qs("[data-label]", b).textContent = "Add"; }, 2200); });
      });
    });

    /* The Deal panel (Philip, 5 Oct 2026: nothing in the buying area takes people off the page). Live: this choice x
       quantity + the cakes already in the cart (the free gift not counted, as in csm-marvellous-deal.js). Below the
       Deal: what is still needed and up to three one-tap ways to get there: this cake in the smallest size that reaches
       it, or this cake + a cake from the "Reach $55" section (its own live variants and prices), added together. */
    var dealDlg = qs("[data-deal-sheet]");
    if (dealDlg && canSheet) {
      var dealSheet = Sheet(dealDlg, true);
      var dsStatus = qs("[data-ds-status]", dealDlg), dsIdeas = qs("[data-ds-ideas]", dealDlg), dsAdded = qs("[data-ds-added]", dealDlg);
      var cartCakes = 0, addedKey = "";
      var loadCart = function () {
        return getCart().then(function (c) {
          cartCakes = 0;
          (c.items || []).forEach(function (i) { if (i.variant_id !== GIFT) cartCakes += i.original_line_price; });
        }).catch(function () {});
      };
      var pairs = qsa("[data-pair-add]").map(function (b) {
        var li = b.closest(".pair"), sum = li && qs("[data-pair-sum]", li), h = li && qs("h3", li);
        return { id: Number(b.getAttribute("data-pair-add")), price: sum ? Number(sum.getAttribute("data-price")) : 0, name: h ? h.textContent.trim() : "", off: b.disabled };
      }).filter(function (p) { return p.id && p.price && !p.off; });
      var mk = function (tag, cls, txt) { var n = document.createElement(tag); if (cls) n.className = cls; if (txt) n.textContent = txt; return n; };
      var tick = '<svg class="icon" aria-hidden="true"><use href="#i-check"/></svg>';
      var thisCake = function (v) { var s = P.sizePos >= 0 ? lab(v.options[P.sizePos]) : ""; return (qty > 1 ? qty + " × " : "") + "this " + (s ? s + " " : "") + "cake"; };
      var dealSay = function (txt) { dsAdded.classList.remove("is-error"); dsAdded.innerHTML = txt; };
      var drawDeal = function () {
        var v = current();
        if (!v) return;
        var sel = v.id + ":" + qty === addedKey ? 0 : v.price * qty;
        var total = cartCakes + sel;
        var on = total >= P.dealCents;
        dealDlg.classList.toggle("is-on", on);
        dsStatus.innerHTML = "";
        var head = mk("p", "ds-head");
        if (on) { head.innerHTML = tick; head.appendChild(document.createTextNode(sel ? "This order gets A Marvellous Deal" : "Your cart gets A Marvellous Deal")); }
        else {
          head.appendChild(document.createTextNode("Add "));
          head.appendChild(mk("b", "", money(P.advertisedCents - total, true)));
          head.appendChild(document.createTextNode(" more to get it"));
        }
        dsStatus.appendChild(head);
        var parts = [];
        if (sel) parts.push(thisCake(v) + " " + money(sel, true));
        if (cartCakes) parts.push("your cart " + money(cartCakes, true));
        if (parts.length) {
          var s = parts.join(" + ") + (parts.length > 1 ? " = " + money(total, true) : "");
          dsStatus.appendChild(mk("p", "ds-sum", s.charAt(0).toUpperCase() + s.slice(1)));
        }
        dsIdeas.innerHTML = "";
        var ideas = [];
        if (!on && sel && P.sizePos >= 0) {
          var best = null;
          P.variants.forEach(function (w) {
            if (!w.available || w.id === v.id) return;
            for (var i = 0; i < w.options.length; i++) if (i !== P.sizePos && w.options[i] !== v.options[i]) return;
            if (cartCakes + w.price * qty < P.dealCents) return;
            if (!best || w.price < best.price) best = w;
          });
          if (best) {
            var sv = best.options[P.sizePos];
            ideas.push({ title: "Make it " + lab(sv), meta: (meta(sv) ? meta(sv) + " · " : "") + "gets the Deal", btn: "Add · " + money(best.price * qty, true), aria: "Add " + lab(sv) + " instead, " + money(best.price * qty, true), go: function () { return addSize(best); } });
          }
        }
        if (!on) {
          pairs.filter(function (p) { return total + p.price >= P.dealCents; })
            .sort(function (x, y) { return x.price - y.price; })
            .slice(0, 3 - ideas.length)
            .forEach(function (p) {
              ideas.push({
                title: "+ " + p.name,
                meta: money(p.price, true) + (sel ? " · together " + money(sel + p.price, true) : "") + " · gets the Deal",
                btn: sel ? "Add both" : "Add · " + money(p.price, true),
                aria: sel ? "Add this cake and the " + p.name + ", " + money(sel + p.price, true) : "Add the " + p.name + ", " + money(p.price, true),
                go: function () { return addPair(p, sel ? v : null); }
              });
            });
        }
        ideas.forEach(function (it) {
          var li = mk("li", "ds-idea"), tt = mk("span", "ds-idea__t");
          tt.appendChild(mk("b", "", it.title)); tt.appendChild(mk("small", "", it.meta));
          var b = mk("button", "ds-idea__b", it.btn); b.type = "button"; b.setAttribute("aria-label", it.aria);
          b.addEventListener("click", function () {
            b.disabled = true;
            it.go().then(function () { b.disabled = false; }, function () { b.disabled = false; });
          });
          li.appendChild(tt); li.appendChild(b); dsIdeas.appendChild(li);
        });
        dsIdeas.hidden = !ideas.length;
        // once this choice is in the cart, the panel's own button would only add a second one
        qs("[data-ds-add]", dealDlg).hidden = !sel;
      };
      var afterAdd = function (key) {
        if (key) addedKey = key;
        dealSay('Added. <a href="' + CART_URL + '">View cart</a>');
        announce();
        return Promise.all([refreshCount(), loadCart()]).then(drawDeal);
      };
      /* a bigger size of this cake: pick it on the page too, then the usual add */
      var addSize = function (w) {
        var sv = w.options[P.sizePos];
        var input = qsa('input[data-option="' + P.sizePos + '"]', form).filter(function (i) { return i.value === sv; })[0];
        if (input) { input.checked = true; render(); }
        add();
        return Promise.resolve();
      };
      var addPair = function (p, v) {
        var items = [];
        if (v) items.push({ id: v.id, quantity: qty });
        items.push({ id: p.id, quantity: 1 });
        return jsonFetch(ADD_URL, { method: "POST", body: JSON.stringify({ items: items }) })
          .then(function () { return afterAdd(v ? v.id + ":" + qty : ""); })
          .catch(function (err) { dsAdded.classList.add("is-error"); dsAdded.textContent = (err && err.message) || "Sorry, that didn’t work. Please try again."; });
      };
      onAdded = function (v, q) { if (dealSheet.isOpen()) afterAdd(v.id + ":" + q); else addedKey = v.id + ":" + q; };
      onRender = function () { if (dealSheet.isOpen()) drawDeal(); };
      qsa('[data-sheet-open="' + dealDlg.id + '"]').forEach(function (a) {
        a.addEventListener("click", function (e) {
          e.preventDefault();
          dsAdded.textContent = "";
          drawDeal();
          dealSheet.open(a);
          loadCart().then(drawDeal);
        });
      });
    }

    /* The delivery dates panel: the earliest date (or the customer's own) in the buying area; the panel holds the month
       calendar, and picking an open date saves it for the cart. */
    var datesDlg = qs("[data-dates-sheet]"), dateLine = qs("[data-date-line]");
    if (datesDlg && dateLine && canSheet && Calendar) {
      var datesSheet = Sheet(datesDlg, false);
      var pFull = null, pFail = false;
      var pSt = { mode: "delivery", pc: "", zone: null, ready: false };
      var pEl = { box: qs("[data-chosen]", datesDlg), label: qs("[data-c-label]", datesDlg), date: qs("[data-c-date]", datesDlg), when: qs("[data-c-when]", datesDlg), by: qs("[data-c-by]", datesDlg), pickedLabel: "Your date, saved for your cart" };
      var pSay = function () {
        var pick = DateStore.get(), next = Calendar.nextOpen();
        /* the line in the buying area: the customer's date, else the earliest (for their postcode once known) */
        var lineDate = pick || (pSt.ready ? earliestFor(pSt.pc, pSt.mode) : next);
        qs("[data-dl-label]", dateLine).textContent = pick ? "Your date" : (pSt.ready && pSt.pc ? "Earliest for " + pSt.pc : "Earliest delivery");
        qs("[data-dl-date]", dateLine).textContent = lineDate ? shortDate(lineDate) + ", " + (pSt.mode === "collect" ? "6–9pm" : whenText(lineDate)) : "WhatsApp us";
        sayEarliest(pEl, pSt, pSt.ready ? pick : null, pFull);
        if (pFail && pick && pEl.label) pEl.label.textContent = "Not saved yet, please try again";
        setWa(datesDlg, pSt, pFull);
        gateCal(qs("[data-month-cal]", datesDlg), stepWait(pSt));
      };
      var pCal = monthCal(qs("[data-month-cal]", datesDlg), {
        pick: DateStore.get,
        next: function () { return pSt.ready ? earliestFor(pSt.pc, pSt.mode) : null; },
        onPick: function (d, st) {
          pFail = false;
          if (st === "open") { pFull = null; DateStore.save(d).catch(function () { pFail = true; pSay(); }); }
          else pFull = d;
          pSay();
        }
      });
      DateStore.sub(function () { pCal.draw(); pSay(); });
      var pBox = qs("[data-pc]", datesDlg);
      if (pBox) postcodeStep(pBox, function (st) { pSt = st; pFull = null; pCal.draw(); pSay(); });
      if (!pBox) pSt.ready = true;
      dateLine.hidden = false;
      dateLine.addEventListener("click", function (e) {
        e.preventDefault();
        pFull = null;
        pCal.show(DateStore.get() || (pSt.ready ? earliestFor(pSt.pc, pSt.mode) : null) || Calendar.nextOpen() || Calendar.tomorrow);
        pSay();
        datesSheet.open(dateLine);
      });
      pSay();
      DateStore.load();
    }

    /* Sticky buy bar appears once the main button has scrolled away (a scroll check, not an observer:
       a jump straight past the button never makes it intersect) */
    var mainBtn = qs("[data-product-form] [data-add]");
    var bar = qs("[data-sticky-buy]");
    var forceBar = params.has("sticky");
    if (mainBtn && bar) {
      var barTick = false;
      var updateBar = function () {
        barTick = false;
        bar.classList.toggle("is-on", forceBar || mainBtn.getBoundingClientRect().bottom <= 0);
      };
      window.addEventListener("scroll", function () { if (!barTick) { barTick = true; requestAnimationFrame(updateBar); } }, { passive: true });
      window.addEventListener("resize", updateBar, { passive: true });
      updateBar();
    }

    /* Gallery: swipe, and the thumbnail strip shows / picks the open photo (visible photos only) */
    if (track) {
      track.addEventListener("scroll", function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        visThumbs().forEach(function (t, k) { if (k === i) t.setAttribute("aria-current", "true"); else t.removeAttribute("aria-current"); });
      }, { passive: true });
      thumbs.forEach(function (t) {
        t.addEventListener("click", function () {
          var k = +t.getAttribute("data-i") || 0;
          track.scrollTo({ left: k * track.clientWidth, behavior: reduceMotion() ? "auto" : "smooth" });
        });
      });
    }
  }

  /* ---------- Cart ---------- */
  var cartRoot = qs("[data-cart-root]");
  if (cartRoot) {
    var sectionId = cartRoot.getAttribute("data-section-id");
    var cartForm = qs("[data-cart-form]", cartRoot);
    var dateAttr = qs("[data-date-attr]", cartRoot);
    /* the cart token (from /cart.js; Liquid has none) keys the "gift declined" memory, as in csm-marvellous-deal.js */
    var token = "";
    var tokenP = getCart().then(function (c) { token = c.token || ""; return token; }).catch(function () { return ""; });
    var pcAttr = qs("[data-postcode-attr]", cartRoot);
    if (pcAttr) Where.fromCart(pcAttr.value);
    var model = { mode: Where.get().mode, date: parseDdmmyyyy(dateAttr && dateAttr.value), st: { mode: Where.get().mode, pc: "", zone: null, ready: Where.get().mode === "collect" }, full: null };
    var DECLINE_KEY = "csm-gift-declined";
    var isDeclined = function () { try { return !!token && localStorage.getItem(DECLINE_KEY) === token; } catch (e) { return false; } };
    var setDeclined = function (on) { try { if (on) localStorage.setItem(DECLINE_KEY, token); else localStorage.removeItem(DECLINE_KEY); } catch (e) { /* private mode */ } };
    var setText = function (sel, txt) { qsa(sel, cartRoot).forEach(function (n) { n.textContent = txt; }); };

    /* A saved date that is no longer bookable (past, full, closed) is cleared and must be picked again */
    if (model.date && Calendar && Calendar.status(model.date) !== "open") {
      model.date = null;
      if (dateAttr) dateAttr.value = "";
      if (pcAttr) pcAttr.value = "";
      jsonFetch(UPDATE_URL, { method: "POST", body: JSON.stringify({ attributes: dateAttrs(null) }) }).catch(function () {});
    }

    var shown = model.date ? new Date(model.date.getFullYear(), model.date.getMonth(), 1)
      : (Calendar ? new Date(Calendar.tomorrow.getFullYear(), Calendar.tomorrow.getMonth(), 1) : new Date());
    var calGrid = qs("[data-cal-grid]", cartRoot);
    var calTitle = qs("[data-cal-title]", cartRoot);
    var calPrev = qs("[data-cal-prev]", cartRoot);
    var calNext = qs("[data-cal-next]", cartRoot);

    var syncAttrs = function () {
      var a = dateAttrs(model.date);
      if (dateAttr) dateAttr.value = a.date;
      if (pcAttr) pcAttr.value = a.postcode;
      return a;
    };
    var saveDate = function () {
      /* the same write as the jQuery picker: cart attribute "date", dd-mm-yyyy; the postcode goes with it (after it) */
      var a = syncAttrs();
      DateStore.put(model.date);
      return jsonFetch(UPDATE_URL, { method: "POST", body: JSON.stringify({ attributes: a }) }).catch(function () {});
    };

    var drawCal = function () {
      if (!Calendar || !calGrid) return;
      calTitle.textContent = MON[shown.getMonth()] + " " + shown.getFullYear();
      var firstMonth = new Date(Calendar.tomorrow.getFullYear(), Calendar.tomorrow.getMonth(), 1);
      var lastMonth = new Date(Calendar.last.getFullYear(), Calendar.last.getMonth(), 1);
      calPrev.disabled = shown <= firstMonth;
      calNext.disabled = shown >= lastMonth;
      qsa(".day, .pad", calGrid).forEach(function (n) { n.remove(); });
      var first = new Date(shown.getFullYear(), shown.getMonth(), 1);
      var offset = (first.getDay() + 6) % 7;
      for (var p = 0; p < offset; p++) { var padEl = document.createElement("span"); padEl.className = "pad"; calGrid.appendChild(padEl); }
      var days = new Date(shown.getFullYear(), shown.getMonth() + 1, 0).getDate();
      var nx = model.st.ready ? earliestFor(model.st.pc, model.mode) : null;
      for (var i = 1; i <= days; i++) {
        var dt = new Date(shown.getFullYear(), shown.getMonth(), i);
        var st = Calendar.status(dt);
        var b = document.createElement("button");
        b.type = "button";
        b.className = "day " + (st === "blocked" ? "full" : st);
        b.textContent = i;
        if (dt.getTime() === Calendar.today.getTime()) b.classList.add("today");
        if (st === "past") b.disabled = true;
        else if (st === "blocked") b.setAttribute("aria-disabled", "true");
        b.setAttribute("aria-label", inWords(dt) + ", " + (st === "past" ? "unavailable" : st === "blocked" ? "full or closed" : "open"));
        if (st === "open") {
          b.setAttribute("aria-pressed", String(!!(model.date && model.date.getTime() === dt.getTime())));
          if (!model.date && nx && nx.getTime() === dt.getTime()) b.classList.add("is-next");
          (function (dd) {
            b.addEventListener("click", function () {
              model.date = dd; model.full = null; saveDate(); drawState();
              var why = qs("[data-checkout-why]", cartRoot); if (why) why.textContent = "";
            });
          })(dt);
        } else if (st === "blocked") {
          (function (dd) { b.addEventListener("click", function () { model.full = dd; drawState(); }); })(dt);
        }
        calGrid.appendChild(b);
      }
    };
    if (calPrev) calPrev.addEventListener("click", function () { shown = new Date(shown.getFullYear(), shown.getMonth() - 1, 1); drawCal(); });
    if (calNext) calNext.addEventListener("click", function () { shown = new Date(shown.getFullYear(), shown.getMonth() + 1, 1); drawCal(); });

    /* Candle and topper go into the order note, ahead of the customer's own words */
    var noteIn = qs("[data-note-in]", cartRoot);
    var noteOut = qs("[data-note-out]", cartRoot);
    var noteLines = qsa("[data-note-line]", cartRoot);
    var noteTimer = null;
    var composeNote = function () {
      var lines = noteLines.filter(function (c) { return c.checked; }).map(function (c) { return c.getAttribute("data-note-line"); });
      var own = noteIn ? noteIn.value.trim() : "";
      if (own) lines.push(own);
      return lines.join(" / ");
    };
    var syncNote = function (save) {
      if (!noteOut) return;
      noteOut.value = composeNote();
      if (save) {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          jsonFetch(UPDATE_URL, { method: "POST", body: JSON.stringify({ note: noteOut.value }) }).catch(function () {});
        }, 400);
      }
    };
    if (noteIn && noteOut) {
      noteIn.removeAttribute("name");
      noteOut.disabled = false;
      noteIn.addEventListener("input", function () { syncNote(true); });
      noteLines.forEach(function (c) { c.addEventListener("change", function () { syncNote(true); }); });
      syncNote(false);
    }

    /* Everything that depends on the date, the mode, the postcode's zone and the (re-rendered) totals */
    var drawState = function () {
      var sub = Number(cartRoot.getAttribute("data-sub")) || 0;
      var total = Number(cartRoot.getAttribute("data-total")) || 0;
      var threshold = Number(cartRoot.getAttribute("data-threshold")) || 5490;
      var feeC = Number(cartRoot.getAttribute("data-fee")) || 800;
      var unlocked = sub >= threshold;
      var collect = model.mode === "collect";
      var z = !collect && model.st.zone && model.st.zone.ok ? model.st.zone : null;
      var fee = collect ? 0 : z ? (unlocked ? z.dealFee : z.fee) : (unlocked ? 0 : feeC);
      setText("[data-fee-label]", collect ? "Self-collect in Yishun" : (z && z.label ? z.label + " delivery" : "Delivery"));
      setText("[data-fee-note]", collect ? "Free" : z && z.label ? "Includes the " + money(z.fee - feeC, true) + " surcharge" : (unlocked ? "Free with the Deal" : "Free from " + money(cfg.dealAdvertisedCents || 5500, true)));
      setText("[data-fee]", fee === 0 ? "Free" : money(fee));
      var feeRow = qs("[data-fee-row]", cartRoot); if (feeRow) feeRow.classList.toggle("lit", fee === 0);
      /* the general surcharge line only until the postcode tells us the zone */
      var sur = qs("[data-surcharge]", cartRoot); if (sur) sur.hidden = collect || !!z;
      setText("[data-total-out]", money(total + fee));

      var chosen = qs("[data-chosen]", cartRoot);
      var co = qs("[data-checkout]", cartRoot);
      var ready = model.st.ready;
      setText("[data-c-label]", collect ? "Collection date" : "Delivery date");
      if (model.date) {
        chosen.classList.remove("is-empty");
        setText("[data-c-date]", inWords(model.date));
        var sun = model.date.getDay() === 0;
        setText("[data-c-when]", collect ? "Collect in Yishun between 6pm and 9pm." : (sun ? "Delivered between 12pm and 4pm (Sunday hours)." : "Delivered between 10am and 3pm."));
      } else {
        chosen.classList.add("is-empty");
        var nx = ready ? earliestFor(model.st.pc, model.mode) : null;
        setText("[data-c-date]", ready ? "Pick a date above" : (collect ? "Pick a date above" : "Enter your postal code first"));
        setText("[data-c-when]", nx ? (collect ? "Earliest collection: " : "Earliest for " + model.st.pc + ": ") + shortDate(nx) : "");
      }
      /* not [disabled]: a tap must still explain why */
      var ok = !!model.date && ready;
      if (co) { co.disabled = false; if (ok) co.removeAttribute("aria-disabled"); else co.setAttribute("aria-disabled", "true"); }
      if (co) { var l = qs("[data-label]", co); if (l) l.textContent = "Check out · " + money(total + fee); }
      setText("[data-short-date]", model.date ? shortDate(model.date) : "No date yet");
      var fullNote = qs("[data-full-note]", cartRoot);
      if (fullNote) { fullNote.hidden = !model.full; fullNote.textContent = model.full ? inWords(model.full) + " is full or closed." : ""; }
      setWa(cartRoot, model.st, model.full);
      gateCal(qs("[data-cal]", cartRoot), stepWait(model.st));

      /* the gift-removed line (only when the Deal is unlocked and the gift was declined) */
      var gr = qs("[data-gift-removed]", cartRoot);
      if (gr) gr.hidden = !(unlocked && isDeclined());
      drawCal();
    };
    var cartBox = qs("[data-pc]", cartRoot);
    if (cartBox) {
      postcodeStep(cartBox, function (st) {
        var was = model.mode;
        model.st = st; model.mode = st.mode; model.full = null;
        syncAttrs();
        drawState();
        if (was !== model.mode && model.date) saveDate();
        var why = qs("[data-checkout-why]", cartRoot); if (why && st.ready) why.textContent = "";
      });
    } else { model.st.ready = true; }

    /* Re-render the parts that depend on the cart (Section Rendering API) */
    var rendering = null, again = false, againLight = false;
    var rerender = function (lightGift) {
      /* one at a time; a request that arrives mid-render runs once more afterwards with the newest cart */
      if (rendering) { again = true; againLight = againLight || !!lightGift; return rendering; }
      cartForm.classList.add("is-busy");
      rendering = fetch(CART_URL + "?section_id=" + encodeURIComponent(sectionId))
        .then(function (r) { return r.text(); })
        .then(function (htmlText) {
          var doc = new DOMParser().parseFromString(htmlText, "text/html");
          var fresh = qs("[data-cart-root]", doc);
          if (!fresh) return;
          if (fresh.getAttribute("data-cart") === "empty") { location.reload(); return; }
          ["data-cart", "data-sub", "data-total", "data-gift-in"].forEach(function (a) { cartRoot.setAttribute(a, fresh.getAttribute(a)); });
          qsa("[data-cart-part]", fresh).forEach(function (part) {
            var mine = qs('[data-cart-part="' + part.getAttribute("data-cart-part") + '"]', cartRoot);
            if (mine) mine.innerHTML = part.innerHTML;
          });
          drawState();
          var g = qs("[data-gift]", cartRoot);
          if (lightGift && g && !html.classList.contains("static") && !reduceMotion()) {
            g.classList.remove("is-lighting"); void g.offsetWidth; g.classList.add("is-lighting");
          }
        })
        .catch(function () { location.reload(); })
        .then(function () {
          cartForm.classList.remove("is-busy"); rendering = null; refreshCount();
          if (again) { var l = againLight; again = false; againLight = false; rerender(l); }
        });
      return rendering;
    };
    var wasGift = Number(cartRoot.getAttribute("data-gift-in")) > 0;
    document.addEventListener("csm:deal-synced", function (e) {
      var nowGift = e.detail && e.detail.giftQuantity > 0;
      rerender(nowGift && !wasGift);
      wasGift = !!nowGift;
    });

    var change = function (line, quantity) {
      cartForm.classList.add("is-busy");
      return jsonFetch(CHANGE_URL, { method: "POST", body: JSON.stringify({ line: line, quantity: quantity }) })
        .then(function () { announce(); return rerender(false); })
        .catch(function () { location.reload(); });
    };

    /* One delegated listener: the lines are re-rendered after every change */
    cartRoot.addEventListener("click", function (e) {
      var t = e.target.closest("button");
      if (!t || !cartRoot.contains(t)) return;
      var line = t.closest("[data-line]");
      if (t.hasAttribute("data-qbtn") && line) {
        var q = Number(line.getAttribute("data-qty")) || 1;
        var nq = Math.max(1, Math.min(99, q + Number(t.getAttribute("data-qbtn"))));
        if (nq !== q) change(Number(line.getAttribute("data-line")), nq);
      } else if (t.hasAttribute("data-remove") && line) {
        change(Number(line.getAttribute("data-line")), 0);
      } else if (t.hasAttribute("data-decline") && line) {
        var ln = Number(line.getAttribute("data-line"));
        cartForm.classList.add("is-busy");
        tokenP.then(function () {
          setDeclined(true);
          wasGift = false;
          change(ln, 0);
        });
      } else if (t.hasAttribute("data-undo")) {
        setDeclined(false);
        cartForm.classList.add("is-busy");
        announce(); /* the Deal script adds the gift back, then fires csm:deal-synced */
        setTimeout(function () { if (cartForm.classList.contains("is-busy") && !rendering) rerender(true); }, 4000);
      } else if (t.hasAttribute("data-add-variant")) {
        t.disabled = true;
        jsonFetch(ADD_URL, { method: "POST", body: JSON.stringify({ items: [{ id: Number(t.getAttribute("data-add-variant")), quantity: 1 }] }) })
          .then(function () { announce(); return rerender(false); })
          .catch(function () { t.disabled = false; });
      }
    });

    /* Check out = the form's submit (name="checkout" goes straight to checkout). Never without a date, and for delivery
       never without a postcode we deliver to. With a postcode, the attributes and note are saved first and checkout
       opens with the shipping postcode filled in (Shopify's checkout[shipping_address][zip] prefill, tested 5 Oct 2026);
       if that save fails, the normal form post still goes to checkout. */
    var leaving = false;
    cartForm.addEventListener("submit", function (e) {
      syncNote(false);
      syncAttrs();
      var why = qs("[data-checkout-why]", cartRoot);
      var stop = function (txt, el) {
        e.preventDefault();
        if (why) why.textContent = txt;
        if (el) el.scrollIntoView({ behavior: reduceMotion() ? "auto" : "smooth", block: "center" });
      };
      if (!model.st.ready) return stop(model.st.zone && model.st.zone.why === "none" ? "We can’t deliver to that postcode. Choose Self-collect, or WhatsApp us." : "Enter your postal code first.", cartBox);
      if (!model.date || !dateAttr || !dateAttr.value) return stop("Choose a delivery or collection date first.", qs("[data-cal]", cartRoot));
      if (leaving) return;
      var pc = model.mode === "delivery" ? model.st.pc : "";
      if (!pc || !window.fetch) return;
      e.preventDefault();
      leaving = true;
      cartForm.classList.add("is-busy");
      var body = { attributes: dateAttrs(model.date) };
      if (noteOut && !noteOut.disabled) body.note = noteOut.value;
      jsonFetch(UPDATE_URL, { method: "POST", body: JSON.stringify(body) })
        .then(function () {
          location.href = "/checkout?checkout%5Bshipping_address%5D%5Bzip%5D=" + encodeURIComponent(pc) + "&checkout%5Bshipping_address%5D%5Bcountry%5D=SG";
        })
        .catch(function () {
          var h = document.createElement("input"); h.type = "hidden"; h.name = "checkout"; h.value = "1"; cartForm.appendChild(h);
          cartForm.submit();
        });
    });

    drawState();
    tokenP.then(drawState);
  }
})();
